import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden" }

import { toRefs, watch } from 'vue';

// Personal
import { useQHeadful } from 'src/view/viewmodel/components/qHeadful.vm';

/**
 * Properties
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'QHeadful',
  props: {
  title: { required: true, type: String, default: '' },
},
  setup(__props) {

// Vendor
const props = __props;
const { title } = toRefs(props);

/**
 * ViewModel
 */
const { watchTitle } = useQHeadful();

/**
 * Watch
 */
watch(
  title,
  (newVal: string) => {
    watchTitle(newVal);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(title)), 1 /* TEXT */))
}
}

})